import { observer } from 'mobx-react'
import React from 'react'
import { ButtonTH, Modal } from 'ui-framework'
import BorrowForm from '../BorrowForm'
import borrowNerd from './borrow-nerd.svg'
import borrowOoki from './borrow-ooki.svg'
import BorrowAssetItem from './BorrowAssetItem'
import BorrowAssetVM from './BorrowAssetVM'

const BorrowAsset = ({ vm }: { vm: BorrowAssetVM }) => {
  const { media } = vm.rootStore.uiStore
  const { borrowStore } = vm
  const { borrowInfo, filteredBorrowItems, searchQuery } = vm.borrowStore

  return (
    <div className="borrow-list__container">
      <div className="padded-1 items-center md-padded-h-2 borrow-list__header">
        <ButtonTH
          onClick={borrowStore.sortList}
          sortBy="asset"
          sortOrder={borrowStore.sortOrder}
          currentSortBy={borrowStore.sortBy}>
          Asset
        </ButtonTH>

        <ButtonTH
          onClick={borrowStore.sortList}
          sortBy="interestRate"
          sortOrder={borrowStore.sortOrder}
          currentSortBy={borrowStore.sortBy}>
          Borrow. Rate
        </ButtonTH>

        <ButtonTH
          onClick={borrowStore.sortList}
          sortBy="liquidity"
          sortOrder={borrowStore.sortOrder}
          currentSortBy={borrowStore.sortBy}>
          Liquidity
        </ButtonTH>
      </div>
      <div className="flex-col">
        {filteredBorrowItems.map((item) => (
          <BorrowAssetItem key={item.asset} vm={vm} item={item} />
        ))}

        {filteredBorrowItems.length === 0 && searchQuery && (
          <p className="txt-center margin-top-2">
            <i>The filter returned 0 result.</i>
          </p>
        )}
      </div>

      {!media.isMobileMedia && !searchQuery && (
        <>
          <img src={borrowOoki} className="borrow__ooki-img" />
          <img src={borrowNerd} className="borrow__nerd-img" />
        </>
      )}

      <Modal isOpen={vm.isBorrowOpen} overlayClassName="borrow" onRequestClose={vm.onClose}>
        {borrowInfo && (
          <BorrowForm
            borrowAsset={borrowInfo.asset}
            interestRate={borrowInfo.interestRate}
            liquidity={borrowInfo.liquidity}
            rootStore={vm.rootStore}
            onSubmit={vm.submit}
            onCancel={vm.onClose}
          />
        )}
      </Modal>
    </div>
  )
}

export default observer(BorrowAsset)
